interface CardProps {
  title: string;
  description: string;
}

export default function Card({ title, description }: CardProps) {
  return (
    <div className="card bg-white shadow-md rounded-lg p-4 m-4">
      <h2 className="text-xl font-bold mb-2">{title}</h2>
      {description.split('\\n').map((item) => (
        <p>{item}</p>
      ))}
    </div>
  );
}
